@if (showDropdown()) {
  <div class="dropdown-container"
    [class.above]="aboveTrigger()"
    [class.below]="!aboveTrigger()"
    [class.left]="leftOfTrigger()"
    [class.right]="!leftOfTrigger()"
    [class]="arrowBackgroundColour() ?? ''"
    [style.right.rem]="arrowOffset()">
    <div class="triangle"></div>
    <ng-content class="content"></ng-content>
  </div>
}
